import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isMobile: false
}

const clientDataSlice = createSlice({
  name: 'clientData',
  initialState,
  reducers: {
    setIsMobile(state, action) {
      state.isMobile = action.payload
    }
  }
})

export const { setIsMobile } = clientDataSlice.actions
export default clientDataSlice.reducer
